import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertDialog } from 'components/alerts';

interface FDInfoProps {
  handleClose: () => void;
  isOpen: boolean;
  duplicates: string[];
  clearDuplicates: () => void;
  continueUpload: () => void;
}
const FileDropInfo: FC<FDInfoProps> = ({ handleClose, isOpen, duplicates, clearDuplicates, continueUpload }) => {
  const { t } = useTranslation();

  const closeDialog = (upload?: typeof continueUpload) => {
    if (upload) {
      upload();
    }
    clearDuplicates();
    handleClose();
  };

  return (
    <AlertDialog
      open={isOpen}
      handleCancel={() => closeDialog()}
      handleConfirm={() => closeDialog(continueUpload)}
      dialogContentTitle={t('documents.upload.exists')}
      cancelText={t('global.actions.no')}
      confirmText={t('global.actions.yes')}
      dialogContentText={duplicates.join('\n')}
    />
  );
};

export default FileDropInfo;
